import { Component, EventEmitter, OnInit, Output, Injector, Inject, inject } from '@angular/core';
import { CommonModule } from '@angular/common';  // <-- Contiene *ngTemplateOutlet
import { MATERIAL_MODULES } from '../../Common/material.config';
import {
    ReactiveFormsModule, FormsModule,
    FormGroup, FormControl, FormArray,
    Validators,
    AbstractControl,
    AsyncValidatorFn,
    ValidationErrors
} from '@angular/forms';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatTimepickerModule } from '@angular/material/timepicker';
import { provideNativeDateAdapter } from '@angular/material/core';
import { Observable, Observer, throwIfEmpty } from 'rxjs';
import { ModalWindowService, MAT_DIALOG_DATA, MatDialogRef } from '../../Common/modal-window/modal-window.service';
import { AlumnisService, IAlumnisRecord } from '../../Common/services/alumnis.service'
import { CustomerService } from '../../Common/services/customer.service';
import { TiposEmpresa } from 'src/app/Common/services/tipos-empresa';
import { HttpErrorResponse } from '@angular/common/http';

// =============================================================================
export function getValidatorDNIUniqueInDB(Component: any): AsyncValidatorFn {
    return (control: AbstractControl): Observable<ValidationErrors | null> => {

        return new Observable((observer: Observer<ValidationErrors | null>) => {
            const dni = control.value;
            const current_id_alumnis = Component.form_alta.controls['id_alumnis'].value;
            if (dni === '') {
                observer.next(null);
                observer.complete()
                return;
            }
            //            console.log('Busco dni: ' + dni);
            Component._AlumnisS.readFilter({ dni: dni }).subscribe({
                next: (r: any[]) => {         // llega un array de arrays con los valores de los campos
                    if (r.length === 0 || (r.length === 1 && r[0]['id_alumnis'] === current_id_alumnis)) {
                        observer.next(null);
                    } else {
                        observer.next({ DNIAlreadyExists: true });
                    }
                    observer.complete();
                },
                error: (e: HttpErrorResponse) => {
                    if (e.status === 401) {
                        Component._ModalWindowS.showMessageError(e.message);
                        Component._CustomerS.submitLogout();
                    }
                    observer.next({ DNIValidationFailed: true });
                    observer.complete();
                }
            });
        });

    }
}

// =============================================================================

// =============================================================================
@Component({
    selector: 'app-inscripciones-edit',
    standalone: true,
    imports: [CommonModule, ReactiveFormsModule, ...MATERIAL_MODULES,
        MatDatepickerModule, FormsModule,
        MatTimepickerModule,
    ],
    providers: [
        provideNativeDateAdapter()
    ],
    templateUrl: './alumnis-edit.component.html',
    styleUrls: ['./alumnis-edit.component.scss']
})
export class AlumnisEditComponent implements OnInit {
    private dialogRef = inject(MatDialogRef);
    public _CustomerS = inject(CustomerService);
    public _ModalWindowS = inject(ModalWindowService);
    public _AlumnisS = inject(AlumnisService);
    private _TiposEmpresaS: TiposEmpresa = inject(TiposEmpresa);
    @Output('onSave') private _onSaveEvent = new EventEmitter<IAlumnisRecord>();

    public lista_empresas: any[] = [];
    public tipos_empresas: string[] = this._TiposEmpresaS.tipos_empresa_list;
    public read_only = this._CustomerS.isOnlyRead();
    public is_admin = this._CustomerS.isContentAdmin();

    public forbidden_columns: string[] = [];

    public form_alta = new FormGroup({
        id_alumnis: new FormControl({ value: 0, disabled: true }),
        num_colegiado: new FormControl({ value: '0', disabled: false }, {
            validators: [
                Validators.required,
                // Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$")
            ],
            asyncValidators: [this._getValidatorNumColegiadoUniqueInDB()],
            updateOn: 'blur'

        }),
        nombre: new FormControl({ value: '', disabled: false }, [Validators.required]),
        apellido1: new FormControl({ value: '', disabled: false }, [Validators.required]),
        apellido2: new FormControl({ value: '', disabled: false }),
        dni: new FormControl({ value: "", disabled: false }, {
            validators: [
                Validators.required,
                // Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$")
            ],
            asyncValidators: [getValidatorDNIUniqueInDB(this)],
            updateOn: 'blur'
        }),
        email: new FormControl({ value: "", disabled: false }, {
            validators: [
                Validators.required,
                Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$")
            ],
            updateOn: 'blur'
        }),
        telefono: new FormControl({ value: '', disabled: false }),
        cargo: new FormControl({ value: '', disabled: false }),
        ano_master: new FormControl({ value: '', disabled: false }),
        tipo_empresa: new FormControl({ value: '', disabled: false }),
        empresa: new FormControl({ value: '', disabled: false }),
        nif_empresa: new FormControl({ value: '', disabled: false }),
        direccion: new FormControl({ value: '', disabled: false }),
        codigo_postal: new FormControl({ value: '', disabled: false }),
        ciudad: new FormControl({ value: '', disabled: false }),
        pais: new FormControl({ value: '', disabled: false }),
        especializacion: new FormControl({ value: '', disabled: false }),

        fecha_alta: new FormControl({ value: new Date(), disabled: false }),
        apellidos: new FormControl({ value: '', disabled: false }),

    });
    //    public asFormArray: FormArray;

    // =========================================================================
    constructor(
        Injector: Injector,
        @Inject(MAT_DIALOG_DATA) public data: IAlumnisRecord
    ) {
        this.dialogRef = Injector.get(MatDialogRef);
        this._CustomerS = Injector.get(CustomerService);
        this._ModalWindowS = Injector.get(ModalWindowService);
        this._AlumnisS = Injector.get(AlumnisService);

        this.forbidden_columns = this._AlumnisS.forbidden_columns;

        this._refresFormData(data);
        this.read_only = this._CustomerS.isOnlyRead();

    }

    // -------------------------------------------------------------------------
    ngOnInit(): void {
    }

    // ---------------------------------------------------------------------------
    get values(): any {

        return this.form_alta.getRawValue();

    }

    // ---------------------------------------------------------------------------
    public onSaveClose(): void {

        this._onSaveEvent.emit(this.values);
        this.dialogRef.close(this.values);

    }

    // ---------------------------------------------------------------------------
    public getErrors(): any[] {
        const errors: string[] = [];

        for (let ctrl_name in <any>this.form_alta.controls) {
            const ctrl = <FormControl>this.form_alta.get(ctrl_name);
            if (ctrl.invalid) {
                errors.push(ctrl_name);
            }
        }
        return errors;
    }

    // ---------------------------------------------------------------------------
    public puedoVerDNI(): boolean {
        const current_customer_id = this._CustomerS.logged_alumni;
        const current_alumni_id = this.form_alta.get('id_alumnis')?.value;

        return this.is_admin || current_customer_id === current_alumni_id;

    }

    // =========================================================================
    // -------------------------------------------------------------------------
    private _refresFormData(data: IAlumnisRecord): void {

        this.form_alta.patchValue(data, { emitEvent: false });

    }

    private _getValidatorNumColegiadoUniqueInDB(): AsyncValidatorFn {
        return (control: AbstractControl): Observable<ValidationErrors | null> => {

            return new Observable((observer: Observer<ValidationErrors | null>) => {
                const num_colegiado = control.value;
                const current_id_alumnis = this.form_alta.controls['id_alumnis'].value;
                if (num_colegiado === '') {
                    observer.next(null);
                    observer.complete()
                    return;
                }
                //            console.log('Busco dni: ' + dni);
                this._AlumnisS.readFilter({ num_colegiado: num_colegiado }).subscribe({
                    next: (r: any[]) => {         // llega un array de arrays con los valores de los campos
                        if (r.length === 0 || (r.length === 1 && r[0]['id_alumnis'] === current_id_alumnis)) {
                            observer.next(null);
                        } else {
                            // this.form_alta.patchValue(r[0]);
                            observer.next({ NumColegiadoAlreadyExists: true });
                        }
                        observer.complete();
                    },
                    error: (e: HttpErrorResponse) => {
                        if (e.status === 401) {
                            this._ModalWindowS.showMessageError(e.message);
                            this._CustomerS.submitLogout();
                        }
                        observer.next({ DNIValidationFailed: true });
                        observer.complete();
                    }
                });
            });

        }
    }
}
